module.exports = __webpack_public_path__ + "img/enterprise_banner1_2.eb24f006.png";